
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogButtonMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogButtonMobileRT(): TemplateResult<dialogButtonMobileRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide  cm_searchBoxDialogButton' }, _createElement('a', {
                'aria-label': 'search',
                'name': 'search',
                'className': 'navUser-action account search',
                'href': '#'
            }, _createElement('i', {
                'className': 'fa fa-user',
                'aria-hidden': 'true'
            }, _createElement('svg', {
                'title': 'search',
                'alt': 'search'
            }, _createElement('use', { 'xlinkHref': '#icon-search' })))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]